<template>
  <v-app class="bcgrnd">
    <v-container fluid grid-list-md text-xs-center style="background-color:#f4f4f4 ;padding: 0;" >
      <v-card flat style="background-color:#f4f4f4" >
    <v-card-title style="padding:0px">
      <h5>Visa Process</h5>
      <v-spacer></v-spacer>



    <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important ;background-color: #ffffff; ">
                        <!-- <avatar :size="32" :username="loggedInUserName"></avatar> -->
                        <v-icon color="warning" style="font-size:30px;">person</v-icon>

                       &nbsp;&nbsp;{{loggedInUserName}}
      <!-- <v-icon>arrow_drop_down</v-icon> -->

    </v-btn>

          <v-dialog v-model="logOutDialog" max-width="290" persistent>
            <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;background-color:orange">
              <v-sheet color="transparent" style="text-align:center">
                <v-icon color="#0d47a1" :size="40">https</v-icon>
              </v-sheet>
              
              <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

   <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Worldwin ?</v-card-text>

              
                <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>&nbsp;&nbsp;
                <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
            </v-card>
          </v-dialog>
    </v-card-title>
  </v-card>
    </v-container>
  

    <v-container  style="max-width:1350px">
    <v-layout row wrap class="my-2 mx-2" >


      <v-flex xs12 sm12 md12>
            <template>
              <v-card color="basil" style="">
                <v-btn @click="onProfile()" style="background-color: #F09522; color: #ffffff;">View My Profile</v-btn>

                <v-card-title class="text-center justify-center py-6">
                  <div class="title">
                    <v-icon color="#b81510">description</v-icon>
                    <h5 class="font-weight-bold text-h5  text-basil" style="color:#F99420;">
                      Visa Process
                  </h5>
                 </div>

                </v-card-title>

                <v-tabs
                  v-model="tab"
                  bg-color="transparent"
                  color="basil"
                  grow
                >
                  <v-tab> Admission Details </v-tab>
                  <v-tab> Medical </v-tab>
                  <v-tab> Fees Payment </v-tab>
                  <v-tab> Financial Docs </v-tab>
                  <v-tab> Online visa Application </v-tab>

                </v-tabs>

                <v-window v-model="tab"> 
                  <!-- Suggested University Start -->
 
                  <v-window-item>
                    <v-card
                      color="basil"
                      flat
                    >
                    <!-- <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;"> -->
                      <v-card-title class="  py-6">
                  <h5 class="font-weight-bold text-h5  text-basil" style="color:#b81510;">
                    Admission Details   </h5>
                </v-card-title>
                       <!-- <h4 style="text-align: center;margin-bottom: 30px;margin-top: 30px; color: #e28b1f;"> </h4> -->
                       <v-card v-for="item in deposit" :key="item.id" class="mock" style="border: 2px solid #F09522; margin: 0px 10px; background-color: #ffffff;border-radius:10px;">

                       <div class="comtainer">
                        <div class="row">
                          <div class="col-lg-6">
                              <ul>
                                <li><p>Country : <span>{{ item.countryName }}</span></p></li>
                                <li><p>University : <span>{{ item.universityName }}</span></p></li>
                                <li><p>Course : <span>{{ item.courseName }}</span></p></li>
                                <!-- <li><p>App Fee : <span>{{ item.applicationFee }}</span></p></li>
                                <li><p>App Through : <span>{{ item.applicationThrough }}</span></p></li> -->
                              </ul>
                          </div>
                          <div class="col-lg-6">
                              <ul>
                                <!-- <li><p>Submission : <span>{{ item.submission }}</span></p></li>
                                <li><p>Submission Status : <span>{{ item.submissionStatus }}</span></p></li> -->
                                <li><p>Offer Status : <span>{{ item.offerStatus }}</span></p></li>
                                <li><p>Admission Date : <span>{{ item.admissionDate }}</span></p></li>
                                <li><p>Admission Amount : <span>{{ item.admissionAmount }}</span></p></li>
                              </ul>
                          </div>
                          <!-- <div class="col-lg-4">
                              <ul>
                                <li><p>Master Agent : <span>{{ item.masterAgent }}</span></p></li>
                                <li><p>Deadline : <span>{{ item.deadline }}</span></p></li>
                                <li><p>Remarks : <span>{{ item.remarks }}</span></p></li>

                              </ul>
                          </div> -->
                        </div>
                       </div>
                      </v-card>

                    </v-card>

                    <p class="mt-3"><strong>Visa Status :</strong> <span style="background-color:#E7FFE3; color: #228B11; padding: 10px;border-radius: 30px; margin-left: 10px;">Visa Approved</span></p>


                  </v-window-item>

                  <!--Suggested UniversityEnd -->
                  <!-- Medical Start -->

                  <v-window-item >
                    <v-card
                      color="basil"
                      flat
                    >
                    <!-- <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;"> -->
                      <v-card-title class="  py-6">
                  <h5 class="font-weight-bold text-h5  text-basil" style="color:#b81510;">
                    Medical Details                 </h5>
                </v-card-title>
                       <!-- <h4 style="text-align: center;margin-bottom: 30px;margin-top: 30px; color: #e28b1f;"> </h4> -->
                       <v-card v-if="leadDetail!=null" class="mock" style="border: 2px solid #F09522; margin: 0px 10px; background-color: #ffffff;border-radius:10px;">

                       <div class="comtainer">
                        <div class="row">
                          <div class="col-lg-6">
                              <ul>
                                <li><p>App. Date : <span>{{ leadDetail.medicalDate }}</span></p></li>
                                <li><p>Medical Vanue : <span>{{ leadDetail.medicalVenue }}</span></p></li>
                                <li><p>Phone No. : <span>{{ leadDetail.medicalPh }}</span></p></li>
                              </ul>
                          </div>
                          <div class="col-lg-6">
                              <ul>
                                <li><p>Medical Status: <span>{{ leadDetail.medicalStatus }}</span></p></li>
                                <li><p>Medical Certificate : <span>{{ leadDetail.medicalCerReq }}</span></p></li>

                              </ul>
                          </div>

                        </div>
                       </div>
                      </v-card>
                    </v-card>
                    <!-- </v-card> -->
                    <div class=""  v-if="leadDetail.medicalCerSrc!= null">
                      <p  class="mt-3" ><strong>Download Medical Certificate :</strong> <span>          <a :href=leadDetail.medicalCerSrc target="_blank">     <v-btn style="background-color: #128f31; color: #ffffff; margin-left: 10px;">Download</v-btn></a> </span></p>

                    </div>

                    
                  </v-window-item>

                  <!-- Medical End -->
                  <!-- Fees Patment Start -->

                  <v-window-item >
                    <v-card
                      color="basil"
                      flat
                    >
                    <!-- <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;"> -->
                      <v-card-title class="  py-6">
                  <h5 class="font-weight-bold text-h5  text-basil" style="color:#b81510;">
                    Fees Payment Details                 </h5>
                </v-card-title>
                       <!-- <h4 style="text-align: center;margin-bottom: 30px;margin-top: 30px; color: #e28b1f;"> </h4> -->
                       <v-card v-if="leadDetail!=null" class="mock" style="border: 2px solid #F09522; margin: 0px 10px; background-color: #ffffff;border-radius:10px;">

                       <div class="comtainer">
                        <div class="row">
                          <div class="col-lg-4">
                              <ul>
                                <li><p>Currency : <span>{{ leadDetail.currency }}</span></p></li>
                                <li><p>Total Fee : <span>{{ leadDetail.totalFee }}</span></p></li>
                              </ul>
                          </div>
                          <div class="col-lg-4">
                            <ul>
                                <li><p>Total Paid : <span>{{ leadDetail.totalPaid }}</span></p></li>
                              </ul>                          
                            </div>
                          <div class="col-lg-4" style="display:flex;align-items: center;">
                            <div class="" style=" text-align: center;">
                              <h5 style="color: #b81510;">{{ dueAmount.toFixed(2) }}</h5>
                              <h5> Due Amount  </h5>

                            </div>
                          </div>

                        </div>
                       </div>
                      </v-card>
                      <p  class="mt-3" style="margin-bottom: 0px;"><strong>Additional Payment Required ? <br></strong> </p>
                       <p v-if="selected3=='Yes'" class="mb-3" style="margin: 0px; font-size: 20px;"> Yes    <v-icon small color="#128f31" >check_circle</v-icon> </p>
                       <p v-if="selected3=='No'" class="mb-3" style="margin: 0px; font-size: 20px;"> No    <v-icon small color="#b81510" >cancel</v-icon> </p>

                       <!-- <p style="margin: 0px; font-size: 20px;"> No    <v-icon small color="primary" >cancle</v-icon> </p> -->

                    <v-card v-if="selected3=='Yes'" class="mock" style="border: 2px solid #F09522; margin: 0px 10px; background-color: #ffffff;border-radius:10px;">

                       <div class="comtainer">
                        <div class="row">
                          <div class="col-lg-4" >
                              <ul>
                                <li><p>Additional Amount: <span> {{ leadDetail.aditionalAmount }}</span></p></li>
                              </ul>
                          </div>
                          <div class="col-lg-4" >
                            <ul>
                                <li><p>Additional Paid Amount : <span>{{ additionalPaid  }}</span></p></li>
                              </ul>                        
                            </div>
                          <div class="col-lg-4">
                            <ul>
                                <li><p>Additional Due Amount  : <span>{{ additionalDue }}</span></p></li>
                              </ul>
                          </div>

                        </div>
                       </div>
                      </v-card>
                 
                    <p  class="mt-3" style="margin-bottom: 0px;"><strong>Additional Amount Paid ? <br></strong> </p>
                       <p v-if="selected4=='Yes'" class="mb-3" style="margin: 0px; font-size: 20px;"> Yes    <v-icon small color="#128f31" >check_circle</v-icon> </p>
                       <p v-if="selected4=='No'" class="mb-3" style="margin: 0px; font-size: 20px;"> No    <v-icon small color="#b81510" >cancel</v-icon> </p>

                       <v-card v-if="selected4=='Yes'" style="border: 2px solid #F09522; background-color: #FFF2E2;border-radius:30px;">
                    <div class="table-responsive">

                      <table class="table">
                    <thead class="table-light" style=" text-align: center;font-weight: 700;background-color: #FFF2E2;">
                      <tr style=" ">
                        <td>#</td>
                        <td>PAID AMOUNT</td>
                        <td>PAYMEMT DATE</td>
                        <td>PAYMENT MODE</td>
                      </tr>
                    </thead>
                    <tbody class="table-tbody">
                      <tr v-for="(item , index) in itemAdded" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.paidAmount }}</td>
                        <td>{{ item.paymentDate }}</td>
                        <td>{{ item.paymentMode }}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                </v-card>
              </v-card>
                  </v-window-item>

                  <!-- Fees Patment End -->
                  <v-window-item >
                    <v-card
                      color="basil"
                      flat
                    >
                    <!-- <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;"> -->
                      <v-card-title class="  py-6">
                  <h5 class="font-weight-bold text-h5  text-basil" style="color:#b81510;">
                    Fees Payment Details                 </h5>
                </v-card-title>
                 
                    <p  class="mt-3" style="margin-bottom: 0px;"><strong>Financial Docs Requried ? <br></strong> </p>
                    <p  class="mb-3" style="margin: 0px; font-size: 20px;"> Yes    <v-icon small color="#128f31" >check_circle</v-icon> </p>
                       <!-- <p v-if="selected5=='No'" class="mb-3" style="margin: 0px; font-size: 20px;"> No <v-icon small color="#b81510" >cancel</v-icon> </p> -->
                    
                       <v-card  style="border: 2px solid #F09522; background-color: #FFF2E2;border-radius:30px;">
                    <div class="table-responsive">

                      <table class="table">
                    <thead class="table-light" style=" text-align: center;font-weight: 700;background-color: #FFF2E2;">
                      <tr style=" ">
                        <td>#</td>
                        <td>DOCUMENT NAME</td>
                        <td>DOWNLOAD</td>
                      </tr>
                    </thead>
                    <tbody class="table-tbody">
                      <tr v-for="(item ,index) in reqDocList" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                          <a :href=item.src target="_blank" class="txt_dec">
                          <v-btn small style="background-color: #128f31; color: #ffffff; margin-left: 10px;">Download</v-btn></a></td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                </v-card>
              </v-card>
                  </v-window-item>
                  <!-- Online Visa Application -->
                  <v-window-item >
                    <v-card
                      color="basil"
                      flat
                    >
                    <!-- <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;"> -->
                      <v-card-title class="  py-6">
                  <h5 class="font-weight-bold text-h5  text-basil" style="color:#b81510;">
                    Visa Application Details                 </h5>
                </v-card-title>
                 
                    <p  class="mt-3" style="margin-bottom: 0px;"><strong>Financial Docs Requried ? <br></strong> </p>
                    <p  class="mb-3" style="margin: 0px; font-size: 20px;"> Yes    <v-icon small color="#128f31" >check_circle</v-icon> </p>
                       <!-- <p v-if="selected5=='No'" class="mb-3" style="margin: 0px; font-size: 20px;"> No <v-icon small color="#b81510" >cancel</v-icon> </p> -->
                       <!-- <div class="" v-if="leadDetail!=null" >
                        <p class="mt-3 mb-3" style="margin-bottom: 0px; color:#b81510;" ><strong>Start Date : <span style="color:#000">{{ leadDetail.startDate }}</span></strong> </p>

                      </div> -->

                       <v-card style="border: 2px solid #F09522; background-color: #FFF2E2;border-radius:30px;">
                    <div class="table-responsive">

                      <table class="table">
                    <thead class="table-light" style=" text-align: center;font-weight: 700;background-color: #FFF2E2;">
                      <tr style=" ">
                        <td>#</td>
                        <td>DOCUMENT NAME</td>
                        <td>DOWNLOAD</td>
                      </tr>
                    </thead>
                    <tbody class="table-tbody">
                      <tr v-for="(item ,index) in onlineDocList" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                          <a :href=item.src target="_blank" class="txt_dec">
                          <v-btn small style="background-color: #128f31; color: #ffffff; margin-left: 10px;">Download</v-btn> </a></td>
                      </tr>


                    </tbody>
                  </table>
                </div>
                </v-card>
              </v-card>
                  </v-window-item>
                </v-window>
              </v-card>   
      </template>


        </v-flex>

    </v-layout>
  </v-container>

  </v-app>
</template>
<script>

</script>
<script>

//import Vue from "vue";
import config from "../../config1.json";
export default {
  components: {
  },
  data() {
    return {
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      logOutDialog: false,
      customerNo: 0,
      productNo: 0,
      presentOrderList: [],
      presentOrder: 0,
      presentOrderAmount: 0,
      deliveredOrderAmount: 0,
      deliveredOrder: 0,
      tab: 'Appetizers',
        items: [
        ],
      search: "",
      deposit: [],
      leadDetail: {
        totalFee: 0,
        totalPaid: 0
      },
      itemAdded: [],
      onlineDocList: [],

      form: {
        notes: null
      },

      leadDetail:null,
    
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Order Code", value: "orderCode" },
        { text: "Order Date", value: "date" },
        { text: "Customer Name", value: "fullName" },
        { text: "Mobile Number", value: "mobileNumber" },
        { text: "Total Amount", value: "totalPrice" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" }
      ],

      status1: ['Visa Approved', 'Visa Rejected', 'Visa not Applied / Withdrawal', 'Visa Application going on', 'Visa Submitted & in process', 'Visa doing by Student'],
      selectedStatus1: null,

      selectedMode: "Cash",
      modes: ["Cash", "Online", "Draft", "Chaque"],

      imagelink: null,
      imageError:'',

      image:{
      size:'',
      height:'',
      width:''
      },
      imageLoaded:false,

      selected1: "Yes",
      selected2: "No",
      selected3: "",
      selected4: "No",
      selected5: "",
      selected6: "",
      options1: ["Yes", "No"],

      selectedStatus: null,
      status: ["Approved", "Not Approved"],

      lead: [],
      selectedLead: null,

      type: null,

      leadDetail: {
        totalFee: 0,
        totalPaid: 0
      },

      deposit: [],

      form: {
        notes: null
      },

      itemAdded1:[],
      itemAdded2:[],
      reqDocList: [],
      onlineDocList: [],
      financialDocList: [],
      financialDocList1: [],

      docId: 0
    };
  },

  methods: {
    onProfile() {
      this.$router.push("/studentProfile");
    },
    getData() {
      let id = sessionStorage.getItem("loggedInUserID");
      this.axios
      .get(config.API + 'Admin/' + id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let studentId = res.data.studentId;
        this.axios
        .get(config.API + `VisaProcesses/` + studentId, {
          headers: {
            Authorization: "bearer " + localStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res.data);
          this.form.notes = res.data.leadDetail.notes;
          this.selectedStatus1 = res.data.leadDetail.status;
          this.leadDetail = res.data.leadDetail;
          this.selected1 = res.data.leadDetail.medicalReq;
          this.selected2 = res.data.leadDetail.medicalCerReq;
          this.selected3 = res.data.leadDetail.aditionalReq;
          this.selected4 = res.data.leadDetail.aditionalPaid;
          this.selected5 = res.data.leadDetail.finalcialDocReq;
          this.selected6 = res.data.leadDetail.onlineDocReq;
          this.selectedStatus = res.data.leadDetail.medicalStatus;
          this.deposit = res.data.deposit;
          // console.log(this.deposit);
          this.itemAdded = res.data.additionalList;

          this.reqDocList = res.data.reqDocList;
          this.itemAdded1 = res.data.reqDocList;

          let lth1 = this.reqDocList.length;
          let lth2 = this.financialDocList.length;

          for(let i = 0; i < lth1; i++) {
            let _docId = this.reqDocList[i].docId;

            for(let j = 0; j < lth2; j++) {
              let _docId1 = this.financialDocList[j].id;

              if(_docId == _docId1) {
                this.financialDocList[j].status = true;
                this.financialDocList[j].docId = this.reqDocList[i].id
              }
            }
          }

          this.onlineDocList = res.data.onlineDocList;
          this.itemAdded2 = res.data.onlineDocList;

          let _lth1 = this.onlineDocList.length;
          let _lth2 = this.financialDocList1.length;

          for(let i = 0; i < _lth1; i++) {
            let _docId2 = this.onlineDocList[i].docId;

            for(let j = 0; j < _lth2; j++) {
              let _docId3 = this.financialDocList1[j].id;

              if(_docId2 == _docId3) {
                this.financialDocList1[j].status = true;
                this.financialDocList1[j].docId = this.onlineDocList[i].id
              }
            }
          }
          
          this.$Progress.finish();
        });
      })
      },      

    onEdit(item) {
      this.$router.push(`/viewSalesOrder/${item.id}`);
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },

  created() {
    this.getData();
  },

  computed: {
      dueAmount: function() {
            let due = [];
            due = JSON.parse(JSON.parse(this.leadDetail.totalFee) - JSON.parse(this.leadDetail.totalPaid));

            return due;
    },

    additionalPaid: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.paidAmount); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    additionalDue: function() {
      return this.leadDetail.aditionalAmount - this.additionalPaid;
    },
  }
};


</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
}
.title h5 {
margin-bottom: 0;
}
.title .v-icon {
font-size: 30px!important;
margin-right: 10px;
}
.bcgrnd {
  background-color: white !important;
  background-size: cover;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
.das-card i{
   font-size: 30px;
   margin-right: 8px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none!important;
  }
}

.das-card {
  text-align: center;
}
.table-light tr td{
  /* font-size: 18px!important;  */
  color: #F09522;
}
.table-light tr{

}
.table-tbody tr td{
  text-align: center;
   /* font-size: 18px!important; */
}
.attendance-card {
  border-radius: 30px!important;
  padding:10px 0px;
  text-align: center;
  border: 2px solid #F09522!important;
    background-color:#fff6ec !important;
}
.date {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date p, .attendance-card h2, .attendance-card p {
  margin-bottom: 0px;
  color: #b81510;

}
.date p , .attendance-card p{
  font-size: 14px;
}
.mock p {
  color:#b81510;

}
.mock span {
  color:#000000;
  font-size: 14px;
}
.mock {
  padding: 15px;
  
}
.mock li p {
  margin-bottom: 0;
  font-size: 14px;
}
</style>
